<template>
  <div>
    <div style="margin-bottom:1rem;">
      <div style="padding-bottom:0.35rem;">
        <span class="us_block_title">历史统计</span>
        <span style="font-size: 0.9rem;color: #9e9e9e;">(最近7天)</span>
      </div>
      <div v-if="loading" style="margin-top:1rem;">
        <LoadingText />
      </div>
      <div style="font-size:0.9rem;" v-else>
        <div style="box-shadow:0 0 14px 0 rgba(0,0,0,.08);">
          <v-card flat style="padding-bottom:0.2rem;">
            <div style="padding:0.5rem;padding-bottom:0;font-size:0.8rem;position: relative;">
              最近7天历史统计
            </div>
            <v-divider style="margin-top:0.5rem;" />
            <E7dayStat ref="day_stat" id="chart1" :data="weekStatData" />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingText from '../../../components/LoadingText.vue'
import E7dayStat from './E7dayStat.vue';
export default {
  components: { LoadingText, E7dayStat },
  props: {
    seqCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true,
      weekStatData: {
        labels: ['06-06', '06-07', '06-08', '06-09', '06-10', '06-11', '06-12'],
        values: [0, 0, 0, 0, 0, 0, 0]
      }
    };
  },
  watch: {
  },
  computed: {},
  mounted() {
    var that = this;
    that.$nextTick(() => {
      that.getLast7DayStat()
    })
    that.windowSize()
  },
  created() {},
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    getLast7DayStat() {
      var that = this
      that.$api.bz.stat7DayCamImage({ seq_code: that.seqCode }).then(res => {
        that.loading = false
        if (!res.success) {
          console.log('获取最近7天历史数据失败', res);
          return
        }
        that.weekStatData = res.data
      })
    },
    windowSize() {
      var that = this
      // 监听窗口大小
      window.onresize = () => {
        return (() => {
          that.$nextTick(() => {
            that.$refs.day_stat.reloadSize()
          })
        })()
      }
    }
  }
};
</script>

<style scoped>

.us-v-app{
  background-color: #f2f2f2;
}

.us-back-lucency {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #fff !important;
  cursor: pointer;
  box-shadow: 1px 1px 5px 1px rgba(255, 255, 255, 0.4) !important;
}
.us-lucency-border {
  border-top: 1px solid #f5f5f5;
}
.v-menu__content {
  background: #fff;
}
.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
</style>
